import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNavSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-10">
            <div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                漫画分类
              </h2>
              <p className="mt-2 text-foreground-500 text-sm md:text-base">
                多种题材任你选择，总有一款适合你
              </p>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-md">
              从甜蜜恋爱到热血战斗，从奇幻异世界到烧脑悬疑，我们精心整理了八大分类，帮你快速找到心仪的漫画作品。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {categories.slice(0, 3).map((cat, idx) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group relative overflow-hidden rounded-2xl p-6 md:p-8 transition-all duration-300 hover:scale-[1.02] cursor-pointer ${
                  idx === 0 ? 'md:row-span-2 bg-background-100' : 'bg-background-100'
                }`}
              >
                <div className={`${idx === 0 ? 'flex flex-col h-full' : 'flex flex-col items-center text-center'}`}>
                  <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mb-4`}>
                    <i className={`${cat.icon} text-2xl`}></i>
                  </div>
                  {idx === 0 ? (
                    <>
                      <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
                        {cat.name}
                      </h3>
                      <p className="text-foreground-500 text-sm leading-relaxed flex-1">
                        {cat.description}
                      </p>
                      <div className="mt-4 inline-flex items-center gap-1 text-primary-500 text-sm font-medium">
                        浏览 {cat.count} 部作品 <i className="ri-arrow-right-line"></i>
                      </div>
                    </>
                  ) : (
                    <>
                      <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                        {cat.name}
                      </h3>
                      <p className="text-foreground-500 text-sm mb-3">{cat.description}</p>
                      <span className="inline-flex items-center gap-1 text-primary-500 text-sm font-medium">
                        浏览 {cat.count} 部作品 <i className="ri-arrow-right-line"></i>
                      </span>
                    </>
                  )}
                </div>
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mt-4">
            {categories.slice(3).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center text-center p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-200 text-foreground-600 group-hover:bg-primary-100 group-hover:text-primary-500 transition-colors mb-2">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400 mt-0.5">{cat.count}部</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}